var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGarage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.984,
    height: 31.653,
    viewBox: "0 0 37.984 31.653",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "casa",
    transform: "translate(0 -42.669)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7378",
    "data-name": "Trazado 7378",
    d: "M73.931,82.206,59.272,73.451a.792.792,0,0,0-.8-.009L43.062,82.2a.792.792,0,0,0-.4.688v19.041a.791.791,0,0,0,.792.791h30.07a.791.791,0,0,0,.793-.791V82.885A.792.792,0,0,0,73.931,82.206Z",
    transform: "translate(-39.497 -28.395)",
    fill: "#ffce54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7379",
    "data-name": "Trazado 7379",
    d: "M37.559,52.255l-18.2-9.5a.791.791,0,0,0-.733,0l-18.2,9.5a.791.791,0,0,0-.425.7v3.165a.792.792,0,0,0,1.157.7l17.835-9.305,17.835,9.305a.791.791,0,0,0,1.157-.7V52.957A.792.792,0,0,0,37.559,52.255Z",
    transform: "translate(0 0)",
    fill: "#ed5564"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7380",
    "data-name": "Trazado 7380",
    d: "M109.864,277.32H86.124a.792.792,0,0,0-.791.792v12.662a.791.791,0,0,0,.791.791h23.74a.79.79,0,0,0,.791-.791V278.112A.791.791,0,0,0,109.864,277.32Z",
    transform: "translate(-79.002 -217.242)",
    fill: "#e6e9ed"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_26349",
    "data-name": "Grupo 26349",
    transform: "translate(9.496 63.244)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7381",
    "data-name": "Trazado 7381",
    d: "M146.258,321.573H128.787a.791.791,0,0,1,0-1.582h17.471a.791.791,0,1,1,0,1.582Z",
    transform: "translate(-127.996 -319.991)",
    fill: "#ccd1d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7382",
    "data-name": "Trazado 7382",
    d: "M146.258,364.243H128.787a.791.791,0,0,1,0-1.582h17.471a.791.791,0,1,1,0,1.582Z",
    transform: "translate(-127.996 -359.495)",
    fill: "#ccd1d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7383",
    "data-name": "Trazado 7383",
    d: "M146.258,406.9H128.787a.792.792,0,0,1,0-1.583h17.471a.792.792,0,1,1,0,1.583Z",
    transform: "translate(-127.996 -398.987)",
    fill: "#ccd1d9"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_12877",
    "data-name": "Rect\\xE1ngulo 12877",
    width: 11.078,
    height: 4.748,
    transform: "translate(13.453 52.957)",
    fill: "#5d9cec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7384",
    "data-name": "Trazado 7384",
    d: "M55.362,449.569H22.126a.791.791,0,0,1,0-1.582H55.362a.791.791,0,0,1,0,1.582Z",
    transform: "translate(-19.752 -375.247)",
    fill: "#656d78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7385",
    "data-name": "Trazado 7385",
    d: "M182.528,170.667H171.45a.792.792,0,0,0-.792.791v4.748a.792.792,0,0,0,.792.791h11.078a.792.792,0,0,0,.793-.791v-4.748A.792.792,0,0,0,182.528,170.667Zm-6.33,4.748h-3.957v-3.166H176.2Zm5.539,0H177.78v-3.166h3.957Z",
    transform: "translate(-157.997 -118.502)",
    fill: "#e6e9ed"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarage);
export default __webpack_public_path__ + "static/media/garage.32fd74399ffdbce90fa8b9106c471693.svg";
export { ForwardRef as ReactComponent };